import { useEffect } from 'react';

const ResourcePrefetch = () => {
  useEffect(() => {
    // Prefetch critical resources on idle
    const prefetchResources = () => {
      const criticalResources = [
        // Only prefetch the most critical images that appear above the fold
        '/static/media/Logo.png',
        // Preload critical fonts if any
      ];

      criticalResources.forEach(url => {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        document.head.appendChild(link);
      });
    };

    // Use requestIdleCallback to avoid blocking main thread
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchResources, { timeout: 2000 });
    } else {
      setTimeout(prefetchResources, 1000);
    }
  }, []);

  return null;
};

export default ResourcePrefetch;